<template>
  <transition name="fade">
    <div class="modal-company-container" v-if="status">
      <Loading v-if="$store.state.level1.isLoading" />
      <div class="modal-company-wrapper">
        <div class="modal-company-header">
          <div class="modal-company-header-container">
            <div class="modal-company-logo">
              <div class="circle mr15">
                <img :src="`${api}/file/${profile.logo}`" alt="" v-if="profile && profile.logo" style="width: 100%;" />
                <div :class="checkTotalInitial(profile.nama_vendor) < 3
                    ? 'initial'
                    : `initial${checkTotalInitial(profile.nama_vendor)}`
                  " v-else>
                  {{ generateInitial(profile.nama_vendor) }}
                </div>
              </div>
              <!-- <img :src="require(`~/assets/img/asana.png`)" alt="" v-else /> -->
            </div>
            <div class="modal-company-header-detail">
              <div class="modal-company-header-detail__company-name">
                <div class="text-bold">
                  {{ profile && profile.nama_vendor }}
                </div>
                <div>
                  <span class="text-bold">
                    {{
                      profile && $get(profile, 'badan_usaha.alias_profile', '-')
                    }}
                  </span>
                  - {{ afiliationClass(profile) }}
                </div>
              </div>
              <div class="modal-company-header-detail__company-rating">
                <div class="column100">
                  <div class="flex-row column100">
                    <div class="flex-row column35">
                      <div class="column45 text-bold">K3L</div>
                      <div class="column5">:</div>
                      <div class="column45" :style="{ color: isK3lExpired(profile.k3l[0]) ? 'red' : 'black' }">
                        {{ profile && $get(profile, 'k3l.0.nilai', 0) }}
                        {{
                          profile &&
                          $getK3lCategories($get(profile, 'k3l.0.nilai', 0))
                        }}
                      </div>
                    </div>
                    <div class="flex-row column35">
                      <div class="column45 ml10  text-bold">Kinerja PO</div>
                      <div class="column5">:</div>
                      <div class="column45">
                        <div>
                          <span :class="profile &&
                                kinerjaPoRating(
                                  $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                                  1
                                )
                                ? 'star-active'
                                : 'star-deactive'
                              ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaPoRating(
                                $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                                2
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaPoRating(
                                $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                                3
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaPoRating(
                                $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                                4
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaPoRating(
                                $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                                5
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                        </div>
                      </div>
                    </div>
                    <div class="flex-row column30">
                      <div class="column45 ml10  text-bold">Dokumen</div>
                      <div class="column5">:</div>
                      <div class="column45 document-indicator-container">
                        <div :class="`document-indicator ${profile && profile.legal_document_status == 1
                            ? ''
                            : 'document-indicator__not-complete'
                          }`
                          ">
                          {{
                            profile && profile.legal_document_status == 1
                            ? 'Complete'
                            : 'Not Complete'
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column100">
                  <div class="flex-row column100">
                    <div class="flex-row column35">
                      <div class="column45 text-bold">KPLH</div>
                      <div class="column5">:</div>
                      <div class="column45" :style="{ color: isKplhExpired(profile.kplh[0]) ? 'red' : 'black' }">
                        {{ profile && $get(profile, 'kplh.0.nilai', 0) }}
                        {{ profile && $get(profile, 'kplh.0.tingkat_resiko') }}
                      </div>
                    </div>
                    <div class="flex-row column35">
                      <div class="column45 ml10 text-bold">Kinerja Kontrak</div>
                      <div class="column5">:</div>
                      <div class="column45">
                        <div>
                          <span :class="profile &&
                              kinerjaKontrakRating(
                                $get(profile, 'kinerja_kontrak.0.grade', 0),
                                1
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaKontrakRating(
                                $get(profile, 'kinerja_kontrak.0.grade', 0),
                                2
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaKontrakRating(
                                $get(profile, 'kinerja_kontrak.0.grade', 0),
                                3
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaKontrakRating(
                                $get(profile, 'kinerja_kontrak.0.grade', 0),
                                4
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                          <span :class="profile &&
                              kinerjaKontrakRating(
                                $get(profile, 'kinerja_kontrak.0.grade', 0),
                                5
                              )
                              ? 'star-active'
                              : 'star-deactive'
                            ">&#9733;</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-content-company for-mobile p-0">
                <div class="card-content-company-wrapper">
                  <div class="text-bold">Kinerja PO</div>
                  <div class="rating-wrapper">
                    <div>
                      <span :class="profile &&
                          kinerjaPoRating(
                            $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                            1
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaPoRating(
                            $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                            2
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaPoRating(
                            $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                            3
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaPoRating(
                            $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                            4
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaPoRating(
                            $get(profile, 'kinerja_po.0.csi_score_avg', 0),
                            5
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                    </div>
                  </div>
                </div>
                <div class="card-content-company-wrapper">
                  <div class="text-bold">Kinerja Kontrak</div>
                  <div class="rating-wrapper">
                    <div>
                      <span :class="profile &&
                          kinerjaKontrakRating(
                            $get(profile, 'kinerja_kontrak.0.grade', 0),
                            1
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaKontrakRating(
                            $get(profile, 'kinerja_kontrak.0.grade', 0),
                            2
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaKontrakRating(
                            $get(profile, 'kinerja_kontrak.0.grade', 0),
                            3
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaKontrakRating(
                            $get(profile, 'kinerja_kontrak.0.grade', 0),
                            4
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                      <span :class="profile &&
                          kinerjaKontrakRating(
                            $get(profile, 'kinerja_kontrak.0.grade', 0),
                            5
                          )
                          ? 'star-active'
                          : 'star-deactive'
                        ">&#9733;</span>
                    </div>
                  </div>
                </div>
                <div class="card-content-company-wrapper">
                  <div class="text-bold">K3L</div>
                  <div>
                    {{ profile && $get(profile, 'k3l.0.nilai', 0) }}
                    {{
                      profile &&
                      $getK3lCategories($get(profile, 'k3l.0.nilai', 0))
                    }}
                  </div>
                </div>
                <div class="card-content-company-wrapper">
                  <div class="text-bold">KPLH</div>
                  <div>
                    {{ profile && $get(profile, 'kplh.0.nilai', 0) }}
                    {{ profile && $get(profile, 'kplh.0.tingkat_resiko') }}
                  </div>
                </div>
                <div class="modal-company-header-btn-mobile" @click="copyToClipboard(profile && profile.id)">
                  <img :src="require(`~/assets/img/icons/share.png`)" alt="" />
                  Bagikan
                </div>
              </div>
            </div>
            <div class="modal-company-header-btn">
              <div class="modal-company-header-btn__close" @click="onClose">
                X
              </div>
              <div class="modal-company-header-btn__btn-container" @click="copyToClipboard(profile && profile.id)">
                <img :src="require(`~/assets/img/icons/share.png`)" alt="" />
                Bagikan
              </div>
            </div>
          </div>
        </div>
        <div class="modal-company-tab-info">
          <div :class="`modal-company-tab-info__btn-${tabCompany == 'perizinan' ? 'active' : 'not-active'
            }`
            " @click="activeTab('perizinan')">
            Perizinan
          </div>
          <div :class="`modal-company-tab-info__btn-${tabCompany == 'informasi' ? 'active' : 'not-active'
            }`
            " @click="activeTab('informasi')">
            Informasi
          </div>
          <div :class="`modal-company-tab-info__btn-${tabCompany == 'legal' ? 'active' : 'not-active'
            }`
            " @click="activeTab('legal')">
            Legal Dokumen
          </div>
          <div :class="`modal-company-tab-info__btn-${tabCompany == 'sio' ? 'active' : 'not-active'
            }`
            " @click="activeTab('sio')">
            SIO
          </div>
          <div :class="`modal-company-tab-info__btn-${tabCompany == 'k3l' ? 'active' : 'not-active'
            }`
            " @click="activeTab('k3l')">
            Kinerja K3L
          </div>
          <div :class="`modal-company-tab-info__btn-${tabCompany == 'kplh' ? 'active' : 'not-active'
            }`
            " @click="activeTab('kplh')">
            Kinerja KPLH
          </div>
        </div>
        <div class="modal-company-content">
          <div class="modal-company-tab-container">
            <Perizinan v-if="tabCompany == 'perizinan'" />
            <Informasi v-if="tabCompany == 'informasi'" />
            <LegalDocument v-if="tabCompany == 'legal'" />
            <SIO v-if="tabCompany == 'sio'" />
            <K3L v-if="tabCompany == 'k3l'" />
            <KPLH v-if="tabCompany == 'kplh'" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { api, api_main } from '../../services/config'
export default {
  props: ['status'],
  components: {
    CompanyCard: () => import('@/components/Organism/CompanyCard.vue'),
    Perizinan: () => import('@/components/CompanyInfo/Perizinan'),
    Informasi: () => import('@/components/CompanyInfo/Informasi'),
    LegalDocument: () => import('@/components/CompanyInfo/LegalDocument'),
    SIO: () => import('@/components/CompanyInfo/SIO'),
    K3L: () => import('@/components/CompanyInfo/K3L'),
    KPLH: () => import('@/components/CompanyInfo/KPLH'),
    Loading: () => import('@/components/utils/Loading'),
  },
  data() {
    return {
      // tabCompany: 'perizinan',
      modalOpen: false,
      api: api_main,
    }
  },
  computed: {
    profile() {
      return this.$store.state.level1.profile
    },
    information() {
      return this.$store.state.level1.information
    },
    tabCompany: {
      get() {
        return this.$store.state.level1.activeTab
      },
      set(value) {
        this.activeTab(value)
      },
    },
  },
  methods: {
    isKplhExpired(data) {
      if (!data || !data.tanggal_berakhir) return false;
      const today = new Date();
      const expirationDate = new Date(data.tanggal_berakhir);
      return expirationDate < today;
    },
    isK3lExpired(data) {
      if (!data || !data.tanggal_berakhir) return false;
      const today = new Date();
      const expirationDate = new Date(data.tanggal_berakhir);
      return expirationDate < today;
    },
    activeTab(value) {
      // this.tabCompany = value
      switch (value) {
        case 'perizinan':
          this.$store.dispatch('level1/setCurrentTab', 'perizinan')
          break
        case 'informasi':
          this.$store.commit('level1/GET_INFO_DATA', 'informasi')
          break
        case 'legal':
          this.$store.commit('level1/GET_LEGAL_DOC', 'legal')
          break
        case 'sio':
          this.$store.commit('level1/GET_SIO_DATA', 'sio')
          break
        case 'k3l':
          this.$store.commit('level1/GET_K3L_DATA', 'k3l')
          break
        case 'kplh':
          this.$store.commit('level1/GET_KPLH_DATA', 'kplh')
          break

        default:
          break
      }
    },
    onClose() {
      this.$store.commit('modalStore/closeModal', {
        name: 'profile',
      })
    },
    copyToClipboard(id) {
      console.log('id: ', id)
      // Teks yang akan disalin ke clipboard
      const teks = `${process.env.VUE_APP_ISUPPLIER_URL}search-result?vendor=${id}`

      // Buat elemen textarea sementara untuk menampung teks yang akan disalin
      const textarea = document.createElement('textarea')
      textarea.value = teks
      document.body.appendChild(textarea)

      // Pilih teks dalam textarea
      textarea.select()
      textarea.setSelectionRange(0, textarea.value.length)

      // Salin teks ke clipboard
      document.execCommand('copy')

      // Hapus elemen textarea sementara
      document.body.removeChild(textarea)

      // Tampilkan pesan sukses
      alert(`
        Teks berhasil disalin: 
        
        ${teks}
      `)
    },
  },
}
</script>
